import { render, staticRenderFns } from "./ViewFields.vue?vue&type=template&id=23c27200&scoped=true&"
import script from "./ViewFields.vue?vue&type=script&lang=js&"
export * from "./ViewFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c27200",
  null
  
)

export default component.exports